(() => {
  class ProductNewForm extends HTMLElement {
    constructor() {
      super();
      this.mutatinObserver = new MutationObserver(this.onMutation.bind(this));
      this.productSection = this.closest("product-new");
      this.form = this.querySelector("form");
      try {
        this.sellingPlans = this.dataset.sellingPlans
          ? JSON.parse(this.dataset.sellingPlans)
          : [];
      } catch (e) {
        this.sellingPlans = [];
      }
      this.isSellingPlanSelected = Array.isArray(this.sellingPlans) && this.sellingPlans.some(
        (plan) => plan.selected
      );
      this.onSubmit = this.onSubmit.bind(this);
      this.onPackSizeChange = this.onPackSizeChange.bind(this);
      this.onPurchaseTypeChange = this.onPurchaseTypeChange.bind(this);
      this.onCountItemClick = this.onCountItemClick.bind(this);
      this.onCountItemKeydown = this.onCountItemKeydown.bind(this);
      this.onCountTriggerClick = this.onCountTriggerClick.bind(this);
      this.onCountDropdownKeydown = this.onCountDropdownKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.checkSellingPlan();
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.form) return;
      const redirectToCheckout = this.productSection?.hasAttribute("data-redirect-checkout");
      let cart =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification");
      if (!redirectToCheckout && cart && typeof cart.open === "function") {
        cart.open();
        if (typeof cart.setUpdating === "function") cart.setUpdating(true);
      }
      const submitButton = this.form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }

      const formData = new FormData(this.form);
      const scheduleSelect = this.form.querySelector(".js-product-new-form-schedule");
      if (scheduleSelect && scheduleSelect.disabled) {
        formData.delete("selling_plan");
      }
      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((s) => s.id).join(",")
        );
        formData.append("sections_url", window.location.pathname);
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
      }

      const fetchOptions =
        typeof fetchConfig !== "undefined"
          ? fetchConfig("javascript")
          : { method: "POST", headers: {} };
      fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest";
      delete fetchOptions.headers["Content-Type"];
      fetchOptions.body = formData;

      const cartAddUrl =
        typeof routes !== "undefined" ? routes.cart_add_url : "/cart/add.js";
      fetch(cartAddUrl, fetchOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            if (submitButton) submitButton.disabled = false;
            if (data.description) console.error(data.description);
            return;
          }
          if (redirectToCheckout) {
            this.resetInteractiveState();
            const checkoutUrl =
              typeof routes !== "undefined" && routes.root
                ? `${routes.root}checkout`
                : "/checkout";
            window.location.href = checkoutUrl;
            return;
          }
          if (!cart) {
            const retryOpenDrawer = () => {
              cart =
                document.querySelector("cart-drawer") ||
                document.querySelector("cart-notification");
              if (cart && typeof cart.renderContents === "function") {
                cart.renderContents(data);
                return;
              }
              if (
                typeof routes !== "undefined" &&
                routes.cart_url
              ) {
                window.location = routes.cart_url;
              }
            };
            setTimeout(retryOpenDrawer, 150);
            return;
          }
          if (typeof cart.renderContents === "function") {
            cart.renderContents(data);
          }
        })
        .catch((err) => {
          console.error(err);
          if (submitButton) submitButton.disabled = false;
        })
        .finally(() => {
          if (cart && typeof cart.setUpdating === "function") {
            cart.setUpdating(false);
          }
          if (submitButton) submitButton.disabled = false;
        });
    }

    checkSellingPlan() {
      if (!window.needToActivateSellingPlan) return;
      if (this.productSection?.hasAttribute("data-disable-url-updates")) return;
      const subscribeRadio = this.querySelector(
        '.js-product-new-form-purchase-type[value="subscribe"]'
      );
      const scheduleSelect = this.form?.querySelector(".js-product-new-form-schedule");
      if (subscribeRadio) subscribeRadio.checked = true;
      if (scheduleSelect) {
        scheduleSelect.disabled = false;
        const option = Array.from(scheduleSelect.options).find(
          (o) => o.value === window.needToActivateSellingPlan
        );
        if (option) scheduleSelect.value = option.value;
      }
      this.updatePurchaseOptionSelection();
      const url = new URL(window.location);
      url.searchParams.set("selling_plan", window.needToActivateSellingPlan);
      this.productSection.replaceLayout(url);

      delete window.needToActivateSellingPlan;
    }

    updatePurchaseOptionSelection() {
      const subscribeItem = this.querySelector(
        ".product-new-form__purchase-option-item--subscribe"
      );
      const onetimeItem = this.querySelector(
        ".product-new-form__purchase-option-item--onetime"
      );
      const subscribeRadio = this.querySelector(
        '.js-product-new-form-purchase-type[value="subscribe"]'
      );
      const onetimeRadio = this.querySelector(
        '.js-product-new-form-purchase-type[value="onetime"]'
      );
      const isSubscribe = subscribeRadio?.checked;
      subscribeItem?.classList.toggle("is-selected", isSubscribe);
      onetimeItem?.classList.toggle("is-selected", !isSubscribe);

      const scheduleSelect = this.form?.querySelector(".js-product-new-form-schedule");
      if (scheduleSelect) {
        scheduleSelect.disabled = !isSubscribe;
      }

      const benefits = subscribeItem?.querySelector("[data-subscribe-benefits]");
      const schedule = subscribeItem?.querySelector("[data-subscribe-schedule]");
      if (benefits) benefits.classList.toggle("is-hidden", !isSubscribe);
      if (schedule) schedule.classList.toggle("is-hidden", !isSubscribe);

      if (subscribeRadio && onetimeRadio && !subscribeRadio.checked && !onetimeRadio.checked) {
        onetimeRadio.checked = true;
        onetimeItem?.classList.add("is-selected");
        subscribeItem?.classList.remove("is-selected");
      }
    }

    formatMoney(cents) {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        return Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat || "${{amount}}"
        );
      }
      return "$" + (cents / 100).toFixed(2);
    }

    updateSubmitButtonPrice() {
      const container = this.querySelector(".js-purchase-option-price-container");
      const subscribeEl = this.querySelector(
        ".product-new-form__submit-price--subscribe"
      );
      const onetimeEl = this.querySelector(
        ".product-new-form__submit-price--onetime"
      );
      if (!subscribeEl && !onetimeEl) return;

      const subscribePrice = container
        ? parseInt(container.dataset.basePrice, 10) || 0
        : 0;
      const onetimePrice = container
        ? parseInt(container.dataset.comparePrice, 10) || 0
        : 0;
      const isOnetime = this.querySelector(
        '.js-product-new-form-purchase-type[value="onetime"]'
      )?.checked;

      if (subscribeEl) {
        subscribeEl.textContent = this.formatMoney(subscribePrice);
        subscribeEl.style.display = isOnetime ? "none" : "inline";
      }
      if (onetimeEl) {
        onetimeEl.textContent = this.formatMoney(onetimePrice);
        onetimeEl.style.display = isOnetime ? "inline" : "none";
      }
    }

    resetDefaultState() {
      if (!this.productSection?.hasAttribute("data-reset-default-state")) return;

      const defaultVariantId = this.dataset.defaultVariantId;
      if (!defaultVariantId || !this.form) return;

      const onetimeRadio = this.querySelector(
        '.js-product-new-form-purchase-type[value="onetime"]'
      );
      if (onetimeRadio) onetimeRadio.checked = true;

      const scheduleSelect = this.form.querySelector(".js-product-new-form-schedule");
      if (scheduleSelect) {
        scheduleSelect.disabled = true;
        if (scheduleSelect.options.length > 0) {
          scheduleSelect.selectedIndex = 0;
        }
      }

      const defaultCountItem = this.querySelector(
        `.js-product-new-form-count-item[data-value="${defaultVariantId}"]`
      );

      if (defaultCountItem) {
        this.selectCountItem(defaultCountItem);
        this.updatePurchaseOptionSelection();
        return;
      }

      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = defaultVariantId;

      const countSelect = this.querySelector(".js-product-new-form-count");
      if (countSelect) countSelect.value = defaultVariantId;

      this.updatePurchaseOptionSelection();
      this.updateSubmitButtonPrice();
    }

    resetInteractiveState() {
      document.body.classList.remove("loading");
      document.body.classList.remove("overflow-hidden");

      this.querySelectorAll(
        '[type="submit"], .js-product-new-form-sticky-submit'
      ).forEach((button) => {
        button.disabled = false;
        button.classList.remove("loading");
      });

      const cart = document.querySelector("cart-drawer");
      if (cart?.classList.contains("active") && typeof cart.close === "function") {
        cart.close();
      }
      if (cart && typeof cart.setUpdating === "function") {
        cart.setUpdating(false);
      }

      this.updatePurchaseOptionSelection();
      this.updateSubmitButtonPrice();
    }

    onPageShow(event) {
      if (!this.productSection?.hasAttribute("data-redirect-checkout")) return;
      if (!event.persisted) return;
      this.resetInteractiveState();
      this.resetDefaultState();
    }

    onPageHide() {
      if (!this.productSection?.hasAttribute("data-redirect-checkout")) return;
      document.body.classList.remove("loading");
      this.querySelectorAll(
        '[type="submit"], .js-product-new-form-sticky-submit'
      ).forEach((button) => {
        button.disabled = false;
      });
    }

    onPackSizeChange() {
      const packSelect = this.form?.querySelector(".js-product-new-form-pack-size");
      const display = this.form?.querySelector(".js-product-new-form-pack-size-display");
      if (!packSelect || !display) return;
      const opt = packSelect.options[packSelect.selectedIndex];
      const mainEl = display.querySelector(".js-product-new-form-pack-size-main");
      const descEl = display.querySelector(".js-product-new-form-pack-size-description");
      if (mainEl) mainEl.textContent = opt?.textContent ?? "";
      if (descEl) descEl.textContent = opt?.dataset.description ?? "";
    }

    onPurchaseTypeChange(event) {
      const value = event.target.value;
      const isSubscribe = value === "subscribe";
      const scheduleSelect = this.form?.querySelector(".js-product-new-form-schedule");
      if (scheduleSelect) {
        scheduleSelect.disabled = !isSubscribe;
      }
      const subscribeItem = this.querySelector('[data-purchase-option="subscribe"]');
      const benefits = subscribeItem?.querySelector("[data-subscribe-benefits]");
      const schedule = subscribeItem?.querySelector("[data-subscribe-schedule]");
      if (benefits) benefits.classList.toggle("is-hidden", !isSubscribe);
      if (schedule) schedule.classList.toggle("is-hidden", !isSubscribe);
      this.updatePurchaseOptionSelection();
      this.updatePriceDisplay();
      this.updateSubmitButtonPrice();
    }

    onCountItemClick(event) {
      this.selectCountItem(event.currentTarget);
    }

    onCountItemKeydown(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.selectCountItem(event.currentTarget);
      }
    }

    onCountTriggerClick() {
      const dropdown = this.querySelector("[data-count-dropdown]");
      const isOpen = dropdown?.classList.contains("is-open");
      if (isOpen) {
        this.closeCountDropdown();
      } else {
        this.openCountDropdown();
      }
    }

    onCountDropdownKeydown(event) {
      if (event.key === "Escape") {
        this.closeCountDropdown();
        this.querySelector(".js-product-new-form-count-trigger")?.focus();
      }
    }

    onDocumentClick(event) {
      if (!this.querySelector("[data-count-dropdown]")?.contains(event.target)) {
        this.closeCountDropdown();
      }
    }

    openCountDropdown() {
      const dropdown = this.querySelector("[data-count-dropdown]");
      const trigger = this.querySelector(".js-product-new-form-count-trigger");
      dropdown?.classList.add("is-open");
      trigger?.setAttribute("aria-expanded", "true");
      document.addEventListener("click", this.onDocumentClick);
    }

    closeCountDropdown() {
      const dropdown = this.querySelector("[data-count-dropdown]");
      const trigger = this.querySelector(".js-product-new-form-count-trigger");
      dropdown?.classList.remove("is-open");
      trigger?.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this.onDocumentClick);
    }

    selectCountItem(item) {
      const variantId = item.dataset.value;
      const title = item.dataset.title;
      const supply = item.dataset.supply;
      const imageSrc = item.dataset.imageSrc;
      const imageAlt = item.dataset.imageAlt;
      const bundleImageSrc = item.dataset.bundleImageSrc;
      const bundleImageAlt = item.dataset.bundleImageAlt;
      const bundleQuantity = parseInt(item.dataset.bundleQuantity, 10) || 1;
      const optionValue = item.dataset.optionValue;
      const price = parseInt(item.dataset.price, 10) || 0;
      const comparePrice = parseInt(item.dataset.comparePrice, 10) || 0;
      const discount = parseInt(item.dataset.discount, 10) || 0;
      const subscriptionDiscount = parseInt(item.dataset.subscriptionDiscount, 10) || 0;
      const featuredMediaId = item.dataset.featuredMediaId || null;

      const select = this.querySelector(".js-product-new-form-count");
      if (select) {
        select.value = variantId;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }

      const variantInput = this.form?.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = variantId;

      if (optionValue) {
        window.dispatchEvent(
          new CustomEvent("pdp:variant:change", {
            detail: { optionValue, variantId, price, comparePrice, imageSrc, imageAlt, bundleImageSrc, bundleImageAlt, bundleQuantity, discount, subscriptionDiscount, featuredMediaId },
          })
        );
      }

      const triggerImg = this.querySelector(".js-product-new-form-count-trigger .product-new-form__count-option-item-image");
      const triggerTitle = this.querySelector(".js-product-new-form-count-trigger-title");
      const triggerSupply = this.querySelector(".js-product-new-form-count-trigger-supply");

      if (triggerImg && imageSrc) {
        triggerImg.src = imageSrc;
        triggerImg.alt = imageAlt ?? "";
      }
      if (triggerTitle) triggerTitle.textContent = title ?? "";
      if (triggerSupply) triggerSupply.textContent = supply ?? "";

      this.querySelectorAll(".js-product-new-form-count-item").forEach((el) => {
        el.classList.toggle("is-selected", el === item);
        el.setAttribute("aria-selected", el === item ? "true" : "false");
      });

      this.closeCountDropdown();
    }

    updatePriceDisplay({ basePrice, comparePrice } = {}) {
      const container = this.querySelector(".js-purchase-option-price-container");
      if (!container) return;

      if (basePrice !== undefined) container.dataset.basePrice = basePrice;
      if (comparePrice !== undefined) container.dataset.comparePrice = comparePrice;

      const price = parseInt(container.dataset.basePrice, 10) || 0;
      const compare = parseInt(container.dataset.comparePrice, 10) || 0;

      const fmt = (cents) => this.formatMoney(cents);

      const currentEl = container.querySelector(".js-purchase-option-price-current");
      const originalEl = container.querySelector(".js-purchase-option-price-original");
      const onetimePriceEl = this.querySelector(".js-purchase-option-onetime-price");

      if (currentEl) currentEl.innerHTML = fmt(price);

      if (originalEl) {
        if (compare > price) {
          originalEl.style.display = "";
          originalEl.querySelector("s").innerHTML = fmt(compare);
        } else {
          originalEl.style.display = "none";
        }
      }

      if (onetimePriceEl) onetimePriceEl.innerHTML = fmt(compare || price);

      this.updateSubmitButtonPrice();
    }

    connectedCallback() {
      this.onVariantChange = this.onVariantChange.bind(this);
      this.form = this.querySelector("form");
      if (!this.form) return;
      this.mutatinObserver.observe(this, { childList: true, subtree: true });
      this.form.addEventListener("change", this.onFormChange.bind(this));
      this.form.addEventListener("submit", this.onSubmit);

      const stickySubmit = this.querySelector(".js-product-new-form-sticky-submit");
      if (stickySubmit) {
        stickySubmit.addEventListener("click", (e) => {
          e.preventDefault();
          this.form.requestSubmit();
        });
      }

      const packSizeSelect = this.form.querySelector(".js-product-new-form-pack-size");
      if (packSizeSelect) {
        packSizeSelect.addEventListener("change", this.onPackSizeChange);
        this.onPackSizeChange();
      }
      this.form.querySelectorAll(".js-product-new-form-purchase-type").forEach((input) => {
        input.addEventListener("change", this.onPurchaseTypeChange);
      });

      this.querySelectorAll(".product-new-form__purchase-option-label").forEach((label) => {
        label.addEventListener("click", () => {
          requestAnimationFrame(() => {
            this.updatePurchaseOptionSelection();
            this.updateSubmitButtonPrice();
          });
        });
      });

      this.updatePurchaseOptionSelection();
      this.updateSubmitButtonPrice();

      if (this.productSection?.hasAttribute("data-redirect-checkout")) {
        this.onPageShow = this.onPageShow.bind(this);
        this.onPageHide = this.onPageHide.bind(this);
        window.addEventListener("pageshow", this.onPageShow);
        window.addEventListener("pagehide", this.onPageHide);
      }

      if (this.productSection?.hasAttribute("data-reset-default-state")) {
        this.form.setAttribute("autocomplete", "off");
        requestAnimationFrame(() => this.resetDefaultState());
      }

      this.querySelectorAll(".js-product-new-form-count-item").forEach((item) => {
        item.addEventListener("click", this.onCountItemClick);
        item.addEventListener("keydown", this.onCountItemKeydown);
      });

      const countTrigger = this.querySelector(".js-product-new-form-count-trigger");
      if (countTrigger) {
        countTrigger.addEventListener("click", this.onCountTriggerClick);
      }
      const countDropdown = this.querySelector("[data-count-dropdown]");
      if (countDropdown) {
        countDropdown.addEventListener("keydown", this.onCountDropdownKeydown);
      }

      this.sellingPlans = Array.isArray(this.sellingPlans) ? this.sellingPlans.map((sellingPlan) => {
        const name = sellingPlan.name;
        const days = parseInt(name.match(/\d+/)?.[0] ?? 0, 10);
        const months = days / 30;
        return { ...sellingPlan, months };
      }) : [];

      window.addEventListener("pdp:variant:change", this.onVariantChange);
    }

    disconnectedCallback() {
      window.removeEventListener("pdp:variant:change", this.onVariantChange);
      if (this.onPageShow) {
        window.removeEventListener("pageshow", this.onPageShow);
      }
      if (this.onPageHide) {
        window.removeEventListener("pagehide", this.onPageHide);
      }
    }

    onVariantChange(event) {
      const { price, comparePrice } = event.detail || {};
      this.updatePriceDisplay({ basePrice: price, comparePrice });
    }

    onMutation() {
      const rechargeWidget = this.querySelector(
        "[data-widget-container-wrapper]"
      );
      if (!rechargeWidget) return;
      this.mutatinObserver.disconnect();
      rechargeWidget.remove();
    }

    onFormChange(event) {
      if (this.productSection?.hasAttribute("data-disable-url-updates")) return;

      const target = event.target;
      const name = target.name;
      const value = target.value;
      const url = new URL(window.location);

      if (name === "purchase_type") {
        if (value === "subscribe") {
          const scheduleSelect = this.form?.querySelector(".js-product-new-form-schedule");
          const planId = scheduleSelect?.value;
          if (planId) url.searchParams.set("selling_plan", planId);
          else {
            const firstPlan = this.sellingPlans[0];
            if (firstPlan) url.searchParams.set("selling_plan", firstPlan.id);
          }
        } else {
          url.searchParams.delete("selling_plan");
        }
        this.productSection.replaceLayout(url);
        return;
      }

      if (name === "selling_plan") {
        url.searchParams.set("selling_plan", value);
        this.productSection.replaceLayout(url);
        return;
      }

      if (name === "option1" || name === "option2" || name === "option3") {
        url.searchParams.set("variant", value);
        const subscribeRadio = this.querySelector(
          '.js-product-new-form-purchase-type[value="subscribe"]'
        );
        if (subscribeRadio?.checked) {
          let sellingPlanName;
          if (target.type === "select-one") {
            const selectedOption = target.options[target.selectedIndex];
            sellingPlanName = selectedOption?.dataset?.sellingPlanName;
          } else {
            sellingPlanName = target.dataset?.sellingPlanName;
          }
          const sellingPlan =
            this.sellingPlans.find((plan) => plan.name === sellingPlanName) ||
            this.sellingPlans[0];
          if (sellingPlan) url.searchParams.set("selling_plan", sellingPlan.id);
        }
        this.productSection.replaceLayout(url);
      }
    }
  }

  if (!customElements.get("product-new-form"))
    customElements.define("product-new-form", ProductNewForm);
})();
